export const phone = { display: "016 12 06 20", href: "tel:+35316120620" }
export const email = "firmadublin@gmail.com"
export const facebook =
  "https://www.facebook.com/DM-Accountancy-Services-327198004072384"
export const address = [
  "Unit 26, Park West Enterprise Centre",
  "Nangor Road",
  "Dublin 12, D12 N2X6",
]
export const hours = [
  { day: "Poniedziałek", time: null },
  { day: "Wtorek", time: "10:00 – 17:00" },
  { day: "Środa", time: "10:00 – 17:00" },
  { day: "Czwartek", time: "10:00 – 17:00" },
  { day: "Piątek", time: "10:00 – 16:00" },
  { day: "Sobota", time: null },
  { day: "Niedziela", time: null },
]

export const offices = [
  {
    city: "Dublin",
    name: "D&M Accountancy LTD",
    address: address.join(", "),
    lat: 53.333675,
    lng: -6.3669386,
    url:
      "https://www.google.com/maps/place/D%26M+Accountancy+LTD/@53.333675,-6.3695135,17z/data=!3m1!4b1!4m6!3m5!1s0x486772ae6e345d8d:0x9259a89a429f0405!8m2!3d53.333675!4d-6.3669386!16s%2Fg%2F11bwp1rn8p",
  },
  {
    city: "Cork",
    name: "D&M Accountancy",
    address: "33 Cook Street, Centre, Cork, T12 DH02",
    lat: 51.8977951,
    lng: -8.4720416,
    url:
      "https://www.google.com/maps/place/D%26M+Accountancy/@51.8977951,-8.4720416,17z/data=!3m1!4b1!4m6!3m5!1s0x4844901094667f27:0x4c8a014699e06f8d!8m2!3d51.8977951!4d-8.4720416!16s%2Fg%2F11bwnd5gjv",
  },
]
